import type { BranchDeliverySettingMiniEntity } from '@/features/branchDeliverySetting/domain/entities/BranchDeliverySettingMiniEntity'
import type { PaymentType } from '@/features/orderPaymentType/domain/enums/PaymentType'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { VehicleTemplateType } from '@/features/vehicleTemplate/domain/enums/VehicleTemplateType'

export class CreateUpdateServiceEntity {
  name?: string
  region?: RegionMiniEntity
  serviceFee?: number
  packageServiceFee?: number
  minimumCartAmountToOrder?: number
  feePerDistance?: number
  pouchDefaultMaxAmountLimit?: number
  largeOrderThreshold?: number
  autoOrderApprovalPriceLimit?: number
  taxRatioPerOrder?: number | null
  commissionAmountPerOrder?: number | null
  mealCommissionAmount?: number | null
  targetDriverDeliveryTime?: number
  targetDriverActiveTime?: number
  commissionAmountPerJetOrder?: number | null
  allowDriverToUpdateOrderWithinRadiusInMeter?: number | null
  orderPaymentTypes?: Array<PaymentType> | null
  allowClientCancelOrderWithinInSecond?: number | null
  zohoBooksBranchId?: string | null
  isScheduledOrderSupported?: boolean
  deliverySystems?: Array<BranchDeliverySettingMiniEntity> | null
  scheduleOrderApprovalMinutes?: number | null
  supportedPackageCargoVehicleTypes?: Array<VehicleTemplateType> | null
  orderExpensiveLimit?: number | null
  automaticReachBranchDistance?: number
  disableAutomaticDriverReach?: boolean
  automaticReachDestinationDistance?: number
}
